import { PlanSeq } from '@mobi/api-types'
import { getPlanSequenceFromSelection } from '@mobi/betslip/helpers/getPlanSequence'
import { isFobDetails } from '@mobi/betslip/helpers/typeGuards'
import type { ShareBetData } from '@core/Areas/ShareBet/types'

const blockedPlanSeqShares = [
  PlanSeq.MysteryDouble1,
  PlanSeq.MysteryDouble2,
  PlanSeq.MysteryDouble3,
  PlanSeq.MysteryDouble4,
  PlanSeq.MysteryDouble5,
  PlanSeq.MysteryDouble6,
  PlanSeq.MysteryDouble7,
  PlanSeq.MysteryQuaddie1,
  PlanSeq.MysteryQuaddie2,
  PlanSeq.MysteryQuaddie3,
  PlanSeq.MysteryQuaddie4,
  PlanSeq.MysteryQuaddie5,
  PlanSeq.MysteryQuaddie6,
  PlanSeq.MysteryQuaddie7,
  PlanSeq.Mystery$3Combo,
  PlanSeq.Mystery$10Combo,
  PlanSeq.AllUp,
  PlanSeq.FootyTipping,
  PlanSeq.SportsTipping,
  PlanSeq.FOBSports,
  PlanSeq.FavouriteNumbers,
  PlanSeq.MysteryTrifectaInOrder,
  PlanSeq.MysteryTrifectaAllways,
  PlanSeq.MysteryQuinellaLegIn,
  PlanSeq.MysteryQuinellaAllways,
  PlanSeq.MysteryFirst4InOrder,
  PlanSeq.MysteryFirst4Allways,
  PlanSeq.MysteryExactaInOrder,
  PlanSeq.MysteryExactaAllways,
  PlanSeq.MysteryWin,
]

export const shouldAllowShareInBetLoop = (data: ShareBetData) => {
  if (data.contextType === 'ticket') {
    const leg = data.share.ticket.legs[0]
    const isComboMulti = data.share.ticket.formula !== null

    return !(
      leg.eventType === 'Feature Races' ||
      leg.eventType === 'Greys Box Challenge' ||
      leg.eventType === 'Jockey Challenge' ||
      blockedPlanSeqShares.includes(data.share.ticket.planSeq) ||
      isComboMulti
    )
  }

  if (data.contextType === 'betslip' || data.contextType === 'quickbet') {
    const details = data.share.items[0].selectionDetails
    const isFoo = isFobDetails(details)
    const isComboMulti = Object.values(data.share.multiReceipt?.formulaResponse ?? {}).some(
      v => v !== null
    )

    return !(
      (isFoo && details.competitionName === 'Futures') ||
      (isFoo && details.competitionName === 'Greys Box Challenge') ||
      (isFoo && details.competitionName === 'Jockey Challenge') ||
      blockedPlanSeqShares.includes(getPlanSequenceFromSelection(data.share.items[0].selection)) ||
      isComboMulti
    )
  }

  return false
}
